import { useTranslation } from "react-i18next"

import { baseColumnDef } from "@/nzds/data-grid"
import { displayResourceCode } from "@/services/bill/bill-resource"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UseResourceColumnOptions {
  field?: string
}

export const useResourceColumn = <TRow extends GridValidRowModel>(
  options: UseResourceColumnOptions = {}
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const field = options.field ?? "resource_type"

  return {
    ...baseColumnDef,
    field,
    filterable: false,
    flex: 1,
    headerName: t("fields.resource.title"),
    minWidth: 140,
    sortable: true,
    valueFormatter: (value: string | null | undefined) =>
      displayResourceCode(value, (key) => t(key)),
  }
}
